var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"odr-table__cell",style:(("vertical-align: " + _vm.verticalAlign + " !important; width: " + _vm.width + " !important;"))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }